module.exports = "https://static.im-cdn.com/mjc/storefront/Runway/static/media/Star.ee44209d.svg";